module.exports = __webpack_public_path__ + "img/definitive-private.01120484.png";